<script lang="ts" setup>
import { computed } from 'vue';

// Icons
import { XCircleIcon } from '@heroicons/vue/solid';

interface Props {
  data?: {
    status: number;
    errors: Array<{
      message: string;
      field: string;
      indexes: [];
      params: [];
    }>;
  };
}

const props = defineProps<Props>();

const grouped_message = computed(() => {
  if (props.data && props.data.errors && props.data.errors.length === 1) {
    return props.data.errors[0].message;
  } else {
    return 'internal_error';
  }
});

const getFields = (e: { message: string; field: string; indexes: []; params: [] }) => {
  const fields: string[] = [];

  if (e.field !== '') {
    fields.push(e.field);
  }
  if (!e.params) {
    e.params = [];
  }

  return [...fields, ...e.params];
};
</script>

<template>
  <Transition name="top-fade">
    <div v-if="data" class="flex items-center gap-[8px] z-[1]">
      <div class="flex items-center">
        <div class="flex-shrink-0">
          <XCircleIcon class="h-[16px] text-error" aria-hidden="true" />
        </div>
        <div class="ml-2">
          <h3 class="text-12 font-semibold text-error">{{ grouped_message }}</h3>
          <div v-if="data.errors && data.errors.length > 1" class="text-12 font-semibold text-error">
            <ul role="list" class="pl-5 space-y-1 list-disc">
              <li v-for="e in data.errors">{{ e.message }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
